import React from 'react';
import LegalLayout from './LegalLayout';

const MentionsLegales = () => (
  <LegalLayout title="Mentions légales" lastUpdated="01/10/2025">
    <h2>Éditeur du site</h2>
    <p>
      <strong>Dénomination sociale :</strong> SARL Eco Casse<br />
      <strong>Forme juridique :</strong> Société à responsabilité limitée (SARL)<br />
      <strong>Capital social :</strong> 617 600 €<br />
      <strong>Siège social :</strong> 1 Rue René Koechlin, 67150 Gerstheim, France<br />
      <strong>RCS :</strong> Strasbourg B 638 501 528<br />
      <strong>SIRET :</strong> 638 501 528 00027<br />
      <strong>TVA intracommunautaire :</strong> FR06 638 501 528
    </p>
    <p>
      <strong>Téléphone :</strong> 03 88 66 13 38<br />
      <strong>E-mail :</strong> <a href="mailto:ecocasse.careco67@gmail.com">ecocasse.careco67@gmail.com</a>
    </p>
    <p>
      <strong>Directeur de la publication :</strong> SARL Eco Casse, représentée par son représentant légal.
    </p>

    <h2>Hébergement du site</h2>
    <p>
      <strong>Hébergeur :</strong> Wix Online Platform Limited<br />
      <strong>Adresse :</strong> 1 Grant's Row, Dublin 2, D02HX96, Irlande<br />
      <strong>Téléphone :</strong> +1 415 639 9034<br />
      <strong>Site web :</strong> <a href="http://www.wix.com" target="_blank" rel="noopener noreferrer">www.wix.com</a>
    </p>

    <h2>Propriété intellectuelle</h2>
    <p>
      L'ensemble du contenu du présent site (notamment les textes, photographies, illustrations, logos, marques, éléments graphiques, bases de données et structure générale du site) est protégé par les dispositions du Code de la propriété intellectuelle et demeure la propriété exclusive de SARL Eco Casse ou de ses partenaires.
    </p>
    <p>
      Toute reproduction, représentation, modification, publication, adaptation ou exploitation, totale ou partielle, de tout élément du site, quel que soit le procédé utilisé, est interdite sans autorisation écrite préalable.
    </p>

    <h2>Données personnelles</h2>
    <p>
      Les traitements de données à caractère personnel réalisés via le site sont décrits dans notre Politique de confidentialité. Celle-ci précise notamment les finalités des traitements, les bases légales, les durées de conservation, les destinataires des données ainsi que les droits des personnes concernées conformément au Règlement Général sur la Protection des Données (RGPD).
    </p>
    <p>
      Pour exercer vos droits d'accès, de rectification, d'effacement, d'opposition, de limitation ou de portabilité, veuillez consulter les modalités indiquées dans notre Politique de confidentialité.
    </p>

    <h2>Cookies</h2>
    <p>
      Lors de la navigation sur le site, des cookies peuvent être déposés sur votre terminal. Un bandeau de gestion du consentement vous permet d'accepter, de refuser ou de personnaliser l'utilisation des cookies.
    </p>
    <p>
      Pour plus d'informations sur les cookies utilisés et leurs finalités, veuillez consulter la rubrique « Cookies » de notre Politique de confidentialité.
    </p>

    <h2>Responsabilité</h2>
    <p>
      SARL Eco Casse s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur le site. Toutefois, elle ne saurait être tenue responsable des erreurs, omissions ou d'une indisponibilité temporaire du service.
    </p>
    <p>
      Les liens hypertextes présents sur le site vers des ressources externes sont fournis à titre informatif. SARL Eco Casse ne peut être tenue responsable du contenu de ces sites tiers.
    </p>

    <h2>Documents complémentaires</h2>
    <p>Les documents suivants sont également consultables sur le site :</p>
    <ul>
      <li>Politique de confidentialité ;</li>
      <li>Politique de gestion des cookies ;</li>
      <li>Conditions Générales de Vente (CGV), lorsque des ventes ou prestations sont proposées en ligne.</li>
    </ul>
  </LegalLayout>
);

export default MentionsLegales;
